import { FC, ReactNode } from 'react';
import { Collapse, CollapseProps } from 'antd';

const { Panel } = Collapse;

type CollapseListProps = {
  items: {
    title: string;
    content: ReactNode;
  }[];
} & CollapseProps;

const CollapseList: FC<CollapseListProps> = ({ items, ...props }) => {
  return (
    <Collapse {...props} bordered={false} style={{ backgroundColor: 'white' }}>
      {items.map(({ title, content }) => (
        <Panel className="header-left" header={title} key={title}>
          {content}
        </Panel>
      ))}
    </Collapse>
  );
};

export default CollapseList;
